import React from 'react';
import Typography from "@mui/material/Typography";
import logo from '../assets/new_logo_selo_redondo_somos.png';

export default function AboutPage(){
  return (
    <div>
      <div style={{ justifySelf: "center" }}>
        <img src={logo} alt="Reconect" style={{ width: "500px", maxWidth: "100%" }} />
      </div>
      <span>
        <div className='reconect-banner'>
          <h5  className='reconect-text' style={{ color: "white" }}>Nossa Identidade</h5>
        </div>
      </span>
      <Typography className="bullet reconect-infos">Somos uma consultoria em Gestão de Pessoas que acredita em conexões humanas, decisões estratégicas e resultados sustentáveis</Typography>
      <br />
      <span>
        <div className='reconect-banner'>
          <h5  className='reconect-text' style={{ color: "white" }}>Quem somos</h5>
        </div>
      </span>
      <Typography className="bullet reconect-infos">
        A Re-conect Consultoria nasceu com o propósito de aproximar pessoas e organizações de forma estratégica e humanizada. 
        Atuamos apoiando empresas na atração, desenvolvimento e gestão de talentos, sempre respeitando a cultura, o momento e os objetivos de cada negócio.
      </Typography>
      <br />
      <Typography className="reconect-training-title-infos">Nossos diferenciais: </Typography>
      <Typography className="bullet reconect-infos">Atuação personalizada, respeitando a realidade de cada empresa</Typography>
      <Typography className="bullet reconect-infos">Comunicação clara, próxima e assertiva</Typography>
      <Typography className="bullet reconect-infos">Soluções práticas que geram impacto no dia a dia</Typography>
      <br />
      <Typography className="reconect-infos">
        Facilitamos conexões verdadeiras entre pessoas e organizações, promovendo desenvolvimento, engajamento e relações profissionais mais alinhadas 
          e sustentáveis. Mais do que consultores, somos parceiros estratégicos na jornada de crescimento de empresas e profissionais.
      </Typography>
      <br />
      <h5 className='reconect-text'>Conectando talentos, re-conectando propósitos</h5>
      <br />
      <br />
    </div>
  );
}
